import { BaseContainerModel } from "../base-container.model";
import {
  bl_mkp_mst_item_hdr_Rowinterface,
  bl_mkp_mst_item_hdr_Rowclass,
} from "../../dbschema/index";
import { bl_mkp_mst_item_line_RowInterface } from "../../dbschema/bl_mkp_mst_item_line.model";
import { bl_mkp_mst_item_ext_RowInterface } from "../../dbschema/bl_mkp_mst_item_ext.model";
import { bl_mkp_mst_item_image_hdr_RowInterface } from "../../dbschema/bl_mkp_mst_item_image_hdr.model";

export class MkpItemContainerModel extends BaseContainerModel {
  bl_mkp_mst_item_hdr: bl_mkp_mst_item_hdr_Rowinterface =
    new bl_mkp_mst_item_hdr_Rowclass();
  bl_mkp_mst_item_lines: bl_mkp_mst_item_line_RowInterface[] = [];
  bl_mkp_mst_item_exts: bl_mkp_mst_item_ext_RowInterface[] = [];
  bl_mkp_mst_item_image_hdrs: bl_mkp_mst_item_image_hdr_RowInterface[] = [];
} 
